<template>
  <div
    class="convention-hall page"
    style="
      width: 100%;
      background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;
    "
  >
    <van-nav-bar class="nav-bar" :title="$t('concubine.concubine')">
    </van-nav-bar>

    <div style="padding-bottom: 40px; background-color: unset">
      <van-tabs
        v-model="active"
        title-active-color="#C571CF"
        line-height="6px"
        line-width="31px"
        @change="onChange"
      >
        <van-tab
          :title="item.name"
          v-for="(item, index) in tabList"
          :key="index"
        >
          <van-list v-model="loading" @load="onLoad">
            <!-- :finished="finished"
					finished-text="没有更多了" -->
            <div class="pblBox" v-show="!isShow">
              <div
                style="width: calc(50% - 5px)"
                v-for="item in data"
                :key="item.id"
                @click="toDetail(item.id)"
              >
                <div class="releaseItem">
                  <div class="imgBox">
                    <div class="van-image" style="width: 100%; height: 100%">
                      <img :src="item.img_url" class="van-image__img" />
                    </div>
                    <div class="aaa">
                      <div
                        style="
                          width: 40%;
                          height: 100%;
                          padding-top: 8px;
                          float: left;
                          margin-left: 10px;
                          height: 32px;
                        "
                      >
                        <img
                          src="/img/home/xing.png"
                          style="
                            height: 32px;
                            width: 32px;
                            vertical-align: middle;
                          "
                        />
                      </div>
                      <div
                        style="
                          height: 100%;
                          padding-bottom: 8px;
                          float: right;
                          margin-right: 0px;
                          height: 26px;
                          line-height: 26px;
                          font-size: 12px;
                          background: linear-gradient(90deg, #fc78af, #f22678);
                          padding-right: 5px;
                          padding-left: 5px;
                          color: #fff;
                          text-align: center;
                          border-radius: 0 0 0 10px;
                        "
                      >
                        {{ $t("foorter.top7") }}
                      </div>
                      <div style="clear: both"></div>
                    </div>
                    <div class="infoBox" style="display: none">
                      <i
                        class="van-icon van-icon-location"
                        style="font-size: 14px"
                        ><!----></i
                      ><span
                        style="font-size: 12px; margin: 0px 0px 0px 2px"
                      ></span>
                      <div class="wantyuebtn">
                        {{ $t("concubine.appointment") }}
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      width: 100%;
                      margin-top: 4px;
                      height: 32px;
                      line-height: 32px;
                      font-size: 14px;
                      color: #000;
                    "
                  >
                    <div
                      style="
                        width: 50%;
                        float: left;
                        margin-left: 2px;
                        text-align: left;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 12px;
                      "
                    >
                      <img
                        :src="item.img_url"
                        style="
                          width: 28px;
                          height: 28px;
                          vertical-align: middle;
                          border-radius: 14px;
                        "
                      />
                      {{ item.xuanfei_name }}
                    </div>
                    <div
                      style="
                        width: 38%;
                        float: right;
                        margin-right: 2px;
                        text-align: right;
                        height: 32px;
                        line-height: 32px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                    >
                      <img
                        src="/img/home/dingwei1.png"
                        style="
                          width: 16px;
                          height: 16px;
                          vertical-align: middle;
                          font-size: 10px;
                        "
                      />{{ item.class_name }}
                    </div>
                    <div style="clear: both"></div>
                  </div>
                  <div style="width: 100%">
                    <div
                      class="tags"
                      style="padding-top: 2px; padding-bottom: 2px"
                    >
                      <van-tag
                        v-for="(tag, index) in item.flagArray"
                        :key="index"
                        :type="tagTypes[index]"
                      >
                        {{ tag }}
                      </van-tag>
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      padding: 0px 0px 4px 0px;
                    "
                  >
                    <van-rate
                      v-model="item.number"
                      color="#ffd21e"
                      size="20px"
                    />
                  </div>
                  <div style="padding: 0.33333rem 0">
                    <div
                      style="
                        text-align: center;
                        background: linear-gradient(90deg, #fc78af, #f22678);
                        color: #fff;
                        padding: 0.33333rem 1rem;
                        border-radius: 3.33333rem;
                        font-size: 0.8rem;
                      "
                    >
                      {{ $t("concubine.appointment") }}>>
                    </div>
                  </div>
                  <div class="di" style="display: none">
                    <div>
                      <span
                        style="
                          display: inline-block;
                          margin-right: 2px;
                          width: 12px;
                          height: 12px;
                          border-radius: 50%;
                          background: rgb(239, 186, 143);
                        "
                      ></span
                      ><span>{{ item.xuanfei_name }}</span>
                    </div>
                    <div>
                      <i
                        class="van-icon van-icon-like"
                        style="color: rgb(220, 99, 161)"
                        ><!----></i
                      ><span>{{ item.dianzan }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="horizontalItem"
              v-show="isShow"
              v-for="item in data"
              :key="item.id"
              @click="toDetail(item.id)"
            >
              <div class="releaseItem">
                <div class="imgBox">
                  <div class="van-image" style="width: 100%; height: 100%">
                    <img :src="item.img_url" class="van-image__img" />
                  </div>
                  <div class="aaa">
                    <div
                      style="
                        width: 40%;
                        height: 100%;
                        padding-top: 8px;
                        float: left;
                        margin-left: 10px;
                        height: 32px;
                      "
                    >
                      <img
                        src="/img/home/xing.png"
                        style="
                          height: 32px;
                          width: 32px;
                          vertical-align: middle;
                        "
                      />
                    </div>
                    <div
                      style="
                        height: 100%;
                        padding-bottom: 8px;
                        float: right;
                        margin-right: 0px;
                        height: 26px;
                        line-height: 26px;
                        font-size: 12px;
                        background: linear-gradient(90deg, #fc78af, #f22678);
                        padding-right: 5px;
                        padding-left: 5px;
                        color: #fff;
                        text-align: center;
                        border-radius: 0 0 0 10px;
                      "
                    >
                      {{ $t("foorter.top7") }}
                    </div>
                    <div style="clear: both"></div>
                  </div>
                  <div class="infoBox" style="display: none">
                    <i
                      class="van-icon van-icon-location"
                      style="font-size: 14px"
                      ><!----></i
                    ><span
                      style="font-size: 12px; margin: 0px 0px 0px 2px"
                    ></span>
                    <div class="wantyuebtn">
                      {{ $t("concubine.appointment") }}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 100%;
                    margin-top: 4px;
                    height: 32px;
                    line-height: 32px;
                    font-size: 14px;
                    color: #000;
                  "
                >
                  <div
                    style="
                      width: 50%;
                      float: left;
                      margin-left: 2px;
                      text-align: left;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      font-size: 12px;
                    "
                  >
                    <img
                      :src="item.img_url"
                      style="
                        width: 28px;
                        height: 28px;
                        vertical-align: middle;
                        border-radius: 14px;
                      "
                    />
                    {{ item.xuanfei_name }}
                  </div>
                  <div
                    style="
                      width: 38%;
                      float: right;
                      margin-right: 2px;
                      text-align: right;
                      height: 32px;
                      line-height: 32px;
                    "
                  >
                    <img
                      src="/img/home/dingwei1.png"
                      style="
                        width: 16px;
                        height: 16px;
                        vertical-align: middle;
                        font-size: 12px;
                      "
                    />{{ item.class_name }}
                  </div>
                  <div style="clear: both"></div>
                </div>
                <div style="width: 100%">
                  <div
                    class="tags"
                    style="padding-top: 2px; padding-bottom: 2px"
                  >
                    <van-tag
                      v-for="(tag, index) in item.flagArray"
                      :key="index"
                      :type="tagTypes[index]"
                    >
                      {{ tag }}
                    </van-tag>
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    padding: 0px 0px 4px 0px;
                  "
                >
                  <van-rate v-model="item.number" color="#ffd21e" size="20px" />
                </div>
                <div style="padding: 0.33333rem 0">
                  <div
                    style="
                      text-align: center;
                      background: linear-gradient(90deg, #fc78af, #f22678);
                      color: #fff;
                      padding: 0.33333rem 1rem;
                      border-radius: 3.33333rem;
                      font-size: 0.8rem;
                    "
                  >
                    {{ $t("concubine.appointment") }}
                  </div>
                </div>
                <div class="di" style="display: none">
                  <div>
                    <span
                      style="
                        display: inline-block;
                        margin-right: 2px;
                        width: 12px;
                        height: 12px;
                        border-radius: 50%;
                        background: rgb(239, 186, 143);
                      "
                    ></span
                    ><span>{{ item.xuanfei_name }}</span>
                  </div>
                  <div>
                    <i
                      class="van-icon van-icon-like"
                      style="color: rgb(220, 99, 161)"
                      ><!----></i
                    ><span>{{ item.dianzan }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addlist: [],
      isShow: false,
      banners: [{}],
      basicData: [],
      active: 0,
      tabList: [],
      data: [],
      page: 0,
      ids: 1,
      tagTypes: ["primary", "success", "danger", "warning"],
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        page: 0,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
    };
  },
  methods: {
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: this.ids, page: this.page },
      }).then((res) => {
        this.data = res.data;
        this.loading = false;
        // const lanng = localStorage.getItem("lang") || "ja";
        this.data.forEach((item) => {
          // console.debug("item",item.img_url)
          const parts = item.flag.split("|");
          item.flag = parts[0];
          // lanng == 'zh'? :lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]: lanng == 'kr'? item.flag = parts[3]: item.flag = parts[4]
          item.flagArray = item.flag.split("，");
        });
        console.log(this.data, 900);
      });
    },
    onLoad() {},
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    getAddress() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        this.tabList = res.data;
        if (this.tabList.length > 0) {
          this.onChange(0);
        }
        // console.debug(this.tabList)
      });
    },
    onChange(index) {
      this.ids = this.tabList[index].id;
      this.loading = true;
      this.data = {};
      this.getxuanfeilist();
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        // console.debug(this.basicData)
        this.getBanner(this.basicData); //获取banner
      });
    },
    getBanner(data) {
      this.banners = data.banners;
    },
  },
  created() {
    this.getAddress();
    this.getBasicConfig();
    // this.getxuanfeilist();
  },
};
</script>

<style lang="less" scoped>
.page {
  position: absolute !important;
}
.nav-bar {
  background: unset;
  height: 100px;
}
.van-nav-bar {
  line-height: 50px;
}
::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #000;
  font-size: 35px;
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
.van-sidebar {
  width: 180px;
}
// /deep/ .van-col{
// padding: 30px 0px;
// }
.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;
}
::v-deep .van-tab {
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;
  flex: 1 0 auto;
}
::v-deep .van-tabs__line {
  background-color: unset;
}
::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

::v-deep .van-row--flex {
  height: 80px;
  line-height: 80px;
}
/deep/ .van-tabs__nav {
  background: unset;
}
/deep/ .van-cell {
  padding: 30px 22px;
  font-size: 30px;
  line-height: 30px;
}
/deep/ .van-loading__text {
  font-size: 32px;
  color: #000;
}
.pblBox {
  display: flex;
  justify-content: space-between;
  padding: 20px 40px;
  flex-wrap: wrap;
}
.releaseItem {
  width: 100%;
  margin-bottom: 30px;
}
.releaseItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 320px;
}
.tags {
  display: flex;
  margin: 0px 0 4px;
  flex-wrap: wrap;
}
.tags .van-tag {
  padding: 15px 10px;
  font-size: 20px;
  margin: 0 6px 2px 0;
  border-radius: 16px;
}
.tagBox {
  font-size: 3vw;
  margin: 10px 0;
}
.di {
  display: flex;
  justify-content: space-between;
  font-size: 3vw;
  color: #666;
}

.releaseItem .imgBox .aaa {
  position: absolute;
  z-index: 9;
  height: 52px;
  width: 100%;
  top: 0vw;
}
.releaseItem .imgBox span {
  position: absolute;
  z-index: 9;
  height: 52px;
  width: 100%;
  top: 0vw;
}
.releaseItem .imgBox span i {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.releaseItem .imgBox .infoBox {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  color: #fff;
  width: 100%;
  height: 8vw;
  padding: 0 20px;
}
.releaseItem .imgBox .infoBox .wantyuebtn {
  border: 2px solid #fff;
  padding: 10px 16px;
  border-radius: 16px;
  opacity: 0.9;
  font-size: 3vw;
  margin-left: auto;
}

.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
</style>
